
import defaultImage from './images/default.jpg';
import eCommerceImage from './images/e_commerce.jpg';
import timelinesImage from './images/timelines.jpg';
import debianDeploymentSuiteImage from './images/debian.jpg';
import mapMyMeetUpsImage from './images/mmmu.jpg';
import remodelLAImage from './images/remodel_la.jpg';

import ECommerce from './descriptions/ECommerce';
import Timelines from './descriptions/Timelines';
import Debian from './descriptions/Debian';
import MMMU from './descriptions/MMMU';
import ConversionToResponsiveDesign from './descriptions/ConversionToResponsiveDesign';
import Extractor from './descriptions/Extractor';

import uxColWidthForItemsPerRow from '../../lib/uxColWidthForItemsPerRow';

const projectsList = [
  [
    // ... 1st row, make note of number of elements in each row.
    [
      'e_commerce',
      'Example E-Commerce App',
      'https://your-website.herokuapp.com/products',
      eCommerceImage,
      ECommerce
    ],

    [
      'extractor',
      'Scraper For a Website Without an API',
      '#',
      // 'https://example.org',
      defaultImage,
      Extractor
    ],

    [
      'debian_deployment_suite',
      'Debian Deployment Suite',
      '#',
      // 'https://example.org',
      debianDeploymentSuiteImage,
      Debian
    ],

    [
      'map_my_meetups',
      'Tool for Mapping Meet Ups',
      '#',
      // 'https://mapmymeetups.herokuapp.com/',
      mapMyMeetUpsImage,
      MMMU
    ]
  ],

  // ... 2nd row
  [
    [
      'remodel_la',
      'Conversion to Responsive Design',
      'https://michael-software-engr.github.io/remodel_la/',
      remodelLAImage,
      ConversionToResponsiveDesign
    ],

    [
      'timelines',
      'Graph of Meet Up Groups Timelines',
      'https://michael-software-engr.github.io/timelines',
      timelinesImage,
      Timelines
    ]
  ]
].map(row => row.map(projectData => ([
  'name', 'title', 'url', 'img', 'description'
].reduce((acc, key, ix) => {
  acc[key] = projectData[ix];
  return acc;
}, {}))));

export default (uxMaxColumnsPerRow) => ({
  list: projectsList,
  uxColumnWidthPerItem: uxColWidthForItemsPerRow(
    uxMaxColumnsPerRow, projectsList
  )
});



// WEBPACK FOOTER //
// ./src/components/projects/projects.js